import date from "@/filters/date";
import currency from "@/filters/currency";
import discount from "@/filters/discount";

export default {
  date,
  currency,
  discount,
};
